import catList from '@components/catList';
import addToCalendar from '@components/addToCalendar';

import sliders from '@modules/sliders';
import lightboxVideo from '@modules/LightboxVideo';

import avalanche from '@components/avalanche/Avalanche';

export default () => {
    Alpine.data('catList', catList);

    Alpine.data('sliders', sliders);
    Alpine.data('lightboxVideo', lightboxVideo);
    Alpine.data('addToCalendar', addToCalendar);

    avalanche();
};
